<template>
  <value-container v-if="view_only" :value="simple?value:view_only_value" :label="label" :md="md"/>
  <v-flex :md4="md==4" :md3="md==3" v-else>
    <b><fs1-span>{{label}}</fs1-span></b>
    <v-select
      v-if="simple"
      :placeholder="value ? undefined : ' seleccionar'"
      v-model="model"
      :items="items"
      :disabled="view_only"
      :prepend-icon="p_icon"
      :class="!value && 'textEmpty'"/>
    <v-select
      v-else
      :placeholder="value ? undefined : ' seleccionar'"
      v-model="model"
      :items="items"
      :item-text="item_text||'name'"
      :item-value="item_value||'id'"
      :disabled="view_only"
      :prepend-icon="p_icon"
      :class="empty_vals.includes(model) && 'textEmpty'"/>
  </v-flex>
</template>
<script>
export default {
  props: ['label','value','md','disabled','items','view_only','item_text','item_value','p_icon','null_val'],
  data() {
    return { model:null }
  },
  computed:{
    empty_vals(){ return this.null_val?[undefined]:[null,undefined]},
    simple(){ return typeof this.items[0] != 'object' },
    view_only_value(){ return (this.items.find(f=>f.id===this.value)||{}).name }
  },
  watch: {
    'value'(v){ this.model=v },
    'model'(v){ this.$emit('update:value', v) }
  },
  created(){ this.model=[undefined].includes(this.value)?null:this.value },
};
</script>
